var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slice',[_c('div',{ref:"embed",staticClass:"slice-embed",style:({'height': _vm.adjustedHeight+'px'})},[_c('prismic-embed',{attrs:{"field":_vm.slice.primary.url}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }